/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioGuruIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-guru-prod" */ './utils').then(
			(m) => m.ForgePioGuruIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon' },
);

const LazyForgePioGuruSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-guru-prod-search-result" */ './utils').then(
			(m) => m.ForgePioGuruSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGuruIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGuruIconComponent />
	</Suspense>
);

export const ForgePioGuruSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioGuruSearchResultIconComponent />
	</Suspense>
);
